import { requestApi } from './Api';

export const getPermissions = (navigate, params) =>
  requestApi({
    url: '/permissions/get',
    params,
    method: 'GET'
  });
